import type { HornId } from "../../types/traffic";

let audioContext: AudioContext | null = null;

function context(): AudioContext {
  audioContext ??= new AudioContext();
  return audioContext;
}

function tone(
  frequency: number,
  durationSeconds: number,
  gainAmount: number,
  type: OscillatorType,
  delaySeconds = 0,
): void {
  const audio = context();
  const now = audio.currentTime + delaySeconds;
  const oscillator = audio.createOscillator();
  const gain = audio.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, now);
  oscillator.frequency.exponentialRampToValueAtTime(
    frequency * 0.93,
    now + durationSeconds,
  );
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(gainAmount, now + 0.018);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + durationSeconds);

  oscillator.connect(gain);
  gain.connect(audio.destination);
  oscillator.start(now);
  oscillator.stop(now + durationSeconds + 0.02);
}

export function playHorn(hornId: HornId): void {
  switch (hornId) {
    case "courtesy":
      tone(520, 0.16, 0.09, "sine");
      tone(660, 0.13, 0.06, "sine", 0.04);
      break;
    case "foghorn":
      tone(110, 0.7, 0.15, "sawtooth");
      tone(138, 0.65, 0.1, "triangle");
      break;
    case "scooter":
      tone(610, 0.22, 0.08, "square");
      tone(760, 0.19, 0.06, "square", 0.03);
      break;
    case "melody":
      tone(440, 0.14, 0.06, "sine");
      tone(554, 0.14, 0.06, "sine", 0.13);
      tone(659, 0.2, 0.07, "sine", 0.26);
      break;
    case "classic":
      tone(340, 0.36, 0.12, "sawtooth");
      tone(425, 0.33, 0.09, "square");
      break;
  }
}

export function playClick(): void {
  tone(520, 0.06, 0.025, "sine");
}

export async function enableAudio(): Promise<void> {
  const audio = context();
  if (audio.state === "suspended") await audio.resume();
}
